/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Row, Spin, Typography } from 'antd';
import Table from 'components/Table';
import moment from 'moment';
import { getKardexSbcEmpleadosVistaOptimized } from 'api/catalogos/KardexSBCEmpleado';
import { checkToken } from 'api/utils';
import currencyFormatter from 'utils/currencyFormatter';

export const kardexSBCEmpleadoPermission = {
  permissionModel: 'kardexsbcempleado',
  catalogsModels: [],
  tabsModels: [],
};

const { Text } = Typography;

// Solo lectura: el Kárdex SBC nace automáticamente al Autorizar un cálculo de
// SBC Variable (ver autorizar_sbc() en nominas/utils/imss_sbc.py) -- nunca se
// captura ni se edita a mano, así que esta tabla no tiene Agregar/Editar/
// Eliminar (se omite `controls`, mismo patrón que el Historial de Errores de
// SBC Variable).
const KardexSBC = ({ empleadoId, permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      if (!empleadoId) {
        setData([]);
        return undefined;
      }
      setLoading(true);
      await checkToken();
      const response = await getKardexSbcEmpleadosVistaOptimized({ empleado_id: empleadoId });
      if (mounted) {
        setData(Array.isArray(response) ? response : []);
        setLoading(false);
      }
      return undefined;
    };
    fetchData();
    return () => { mounted = false; };
  }, [empleadoId]);

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 120,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Movimiento',
      dataIndex: 'movimiento_sbc_imss_descripcion',
      key: 'movimiento_sbc_imss_descripcion',
      width: 200,
    },
    {
      titleText: 'Ejercicio',
      dataIndex: 'periodo_fiscal_periodo',
      key: 'periodo_fiscal_periodo',
      width: 100,
    },
    {
      titleText: 'Bimestre',
      dataIndex: 'bimestre_nombre',
      key: 'bimestre_nombre',
      width: 150,
      render: (val, record) => (val ? `${val} (${record?.meses_del_bimestre || ''})` : ''),
    },
    {
      titleText: 'Plaza / Puesto',
      dataIndex: 'clave_y_descripcion',
      key: 'clave_y_descripcion',
      width: 250,
    },
    {
      titleText: 'Área',
      dataIndex: 'clave_y_nombre',
      key: 'clave_y_nombre',
      width: 220,
    },
    {
      titleText: 'Sueldo Diario',
      dataIndex: 'sueldo_diario',
      key: 'sueldo_diario',
      width: 130,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Factor SBC',
      dataIndex: 'factor_sbc',
      key: 'factor_sbc',
      width: 110,
      align: 'right',
    },
    {
      titleText: 'SBC Sueldo Fijo',
      dataIndex: 'sbc_sueldo_fijo',
      key: 'sbc_sueldo_fijo',
      width: 140,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'SBC Sueldo Variable',
      dataIndex: 'sbc_sueldo_variable',
      key: 'sbc_sueldo_variable',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Tope SBC',
      dataIndex: 'tope_sbc',
      key: 'tope_sbc',
      width: 130,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'SBC',
      dataIndex: 'sbc',
      key: 'sbc',
      width: 130,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 120,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!empleadoId ? (
          <Text type="secondary">Guarda el empleado para consultar su Kárdex SBC.</Text>
        ) : (
          <Table
            cols={columns}
            data={data}
            permission={permission}
            allowExportPDF={false}
          />
        )}
      </Spin>
    </Row>
  );
};

export default KardexSBC;
